export enum RefundCodeTabType {
  DETAILS = 'details'
}

export interface RefundCode {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  refund_code_id: string
  explanation: string
}

export interface FetchRefundCodeListParams {
  bypass_pagination?: boolean
  sort_by?: string
  sort_order?: string
  start_index?: string
  count?: number
}
